import React, { useEffect, useState } from "react";
import styles from "./scoreCard.module.css";
import {
  fetchAllTeamsPoints,
  fetchTeamsPointsByGroup,
  teamsPerformanceGroup,
} from "../../services/apiEndpoints";
const ScoreCard = () => {
   const [isTeamView, setIsTeamView] = useState(true);
  const [open, setOpen] = useState(false);
  const [teams, setTeams] = useState([]);
  const [groups, setGroups] = useState([]);
  const [performanceData, setPerformanceData] = useState([])


   // Fetch All Team Groups 

  const fetchAllTeamsGroups = async () => {
    try {
      const AllGroupRespo = await fetchTeamsPointsByGroup();
      console.log("groups by teams", AllGroupRespo);
      setGroups(AllGroupRespo);
    } catch (error) {
      console.log("Groups error is", error);
    }
  };


  // Fetch All Team 

  const fetchAllTeams = async () => {
    try {
      const AllTeamRespo = await fetchAllTeamsPoints();
      console.log("teams", AllTeamRespo);
      setTeams(AllTeamRespo);
    } catch (error) {
      console.log("teams error is", error);
    }
  };

  const teamsData = teams?.data;
  const groupsData = groups?.data;
  // const teamRowId = teams.data.team_row_id;



// Fetch Team Performance 

const fetchTeamsPerformanceGroup = async(teamRowId) => {
  try {
    const TeamsPerformanceRespo = await teamsPerformanceGroup(teamRowId);
    console.log("teams Performance Data is ", TeamsPerformanceRespo.data);
    setPerformanceData(TeamsPerformanceRespo.data)
    
  } catch (error) {
    console.log("teams performance error is", error);
    
  }
}


useEffect(() => {
    fetchAllTeams();
    fetchAllTeamsGroups();
  }, []);


  
  return (
    <>
      {open && (
      <div className={styles.modal}>
      <div className={styles.mainModal}>
          <div className={styles.closeModal} onClick={() => setOpen(false)}>
            ←
          </div>
          <table className={styles.table}>
            <thead>
              <tr>
                <th colSpan="4">Team Summery</th>
              </tr>
              <tr>
                <th>Date</th>
                <th>Game</th>
                <th>Result</th>
                <th>Points</th>
              </tr>
            </thead>
            <tbody>
              {performanceData.map((item, index) => (
               <React.Fragment key={index}>
                <tr key={item.id}>
                  <td>{item?.game_date}</td>
                  <td>{item?.sport_name}</td>
                  <td>{item?.result}</td>
                  <td>{item?.points}</td>
                </tr>
                
               </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
        </div>
      )}
      <div className={styles.container}>
        {/* Toggle Button */}
        <div className={styles.toggle}>
          <button
            className={`${styles.button} ${
              isTeamView ? styles.active : styles.inactive
            }`}
            onClick={() => setIsTeamView(true)}
          >
            Team
          </button>
          <button
            className={`${styles.button} ${
              !isTeamView ? styles.active : styles.inactive
            }`}
            onClick={() => setIsTeamView(false)}
          >
            Group
          </button>

          {/* Background slider adjustment */}
          <style>
            {`${styles.toggle}::before { left: ${
              isTeamView ? "2px" : "128px"
            }; }`}
          </style>
        </div>

        {/* Team View  */}
        {isTeamView && (
          <div className={styles.teamContainer}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>Pos</th>
                  <th>Team Name</th>
                  <th>Group</th>
                  <th>Matches</th>
                  <th>Points</th>
                </tr>
              </thead>
              <tbody>
                {teamsData &&
                  teamsData.map((team, index) => {
                    return (
                      <tr key={index} onClick={() => {
                        setOpen(true) 
                        fetchTeamsPerformanceGroup(team?.team_row_id);
                      }

                   }>

                        <td>{index + 1}</td>
                        <td className={styles.teamName}>{team?.team_name}</td>
                        <td>{team?.group_name}</td>
                        <td>{team?.total_matches}</td>
                        <td>{team?.points}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}

        {/* Group View  */}
        {!isTeamView && (
          <>
            {groupsData &&
             groupsData.map((group,index) => (
              <div key={index} className={styles.group}>
                <table className={styles.table}>
                  <thead>
                    <tr>
                      <th colSpan="3"> {group?.group_name}</th>
                    </tr>
                    <tr>
                    <th className={styles.rank}>Pos</th>
                    <th>Team</th>
                    <th className={styles.point}>Points</th>
                  </tr>
                  </thead>
                  <tbody>
                  { group?.teams.map((team, index) => (
                    <tr key={index}>
                      <td className={styles.rank}>{index + 1}</td>
                      <td>{team?.team_name}</td>
                      <td className={styles.point}>{team?.points}</td>
                    </tr>
                  ))}
                  </tbody>
                </table>
              </div>
            ))}
          </>
        )}
      </div>
    </>
  );
};

export default ScoreCard;
















